import React from 'react'
import Snuggle from 'react-snuggle'

import * as UI from '@/components/UI'
import { Label, SmallText } from '@/components/UI/Typography/Typography'
import {
  Section,
  Grid,
  MainCell,
  Description,
  Detail,
  DetailTitle,
  DownloadButton,
  DetailSpacer,
  DetailLabel,
  DetailText,
  ImageCell,
  ImageWrapper,
  WrapperNewSection,
  WrapperDetail,
} from './TemplateHero.css'

const SeriousGamesTemplateHero = ({ content, color = 'blue', variant }) => {
  return (
    <Section>
      <UI.Container>
        <Grid>
          <MainCell>
            <UI.SectionTitle>{content.hero_title}</UI.SectionTitle>
            <Description>{content.hero_description}</Description>
            <UI.Group>
              {content.hero_buttons.map(({ title, link }) => (
                <UI.Button to={link} appearance={color}>
                  {title}
                </UI.Button>
              ))}
            </UI.Group>
            {variant !== 'portfolio' && (
              <UI.Group fullWidth>
                {content.hero_details.map(x => (
                  <Detail>
                    <div style={{ minWidth: '25%' }}>
                      <DetailTitle>{x.title}</DetailTitle>
                      {x.button_title && x.file.url && (
                        <DownloadButton
                          to={x.file.url}
                          appearance='ghost'
                          color={color}
                        >
                          <UI.Icon.Download />
                          {x.button_title}
                        </DownloadButton>
                      )}
                    </div>
                    <DetailSpacer />
                    <div>
                      <DetailLabel>{x.duration_title}</DetailLabel>
                      <DetailText>{x.duration}</DetailText>
                      <DetailLabel>{x.vacancy_title}</DetailLabel>
                      <DetailText>{x.vacancy}</DetailText>
                    </div>
                  </Detail>
                ))}
              </UI.Group>
            )}
            {variant === 'portfolio' && content.new_section_hero.length > 0 && (
              <UI.Group fullWidth>
                <WrapperDetail>
                  {content.new_section_hero.map(x => (
                    <WrapperNewSection key={x.title}>
                      <Label
                        color='gray'
                        style={{ textTransform: 'uppercase' }}
                      >
                        {x.title}
                      </Label>
                      <SmallText>{x.description}</SmallText>
                    </WrapperNewSection>
                  ))}
                </WrapperDetail>
              </UI.Group>
            )}
          </MainCell>
          <ImageCell>
            <Snuggle container={<ImageWrapper />}>
              {content.hero_image.map(img => {
                return <UI.Image src={img.image} />
              })}
            </Snuggle>
          </ImageCell>
        </Grid>
      </UI.Container>
    </Section>
  )
}

export default SeriousGamesTemplateHero
